import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CoreService, QueovalDateService, HttpService, FilesManagerService } from '../../services';
import { ToastService } from '../../toast';
import { Chapter, CycleEL, LessonQuestionnaireModel, ChartQuestionnaireModel, AnswerModel, LearnerDetail, QueovalDate, ChartData, FileModel, QResult } from '../../models';
import { isEmptyStr } from '../../utilities';
import * as _ from 'lodash';

declare var $: any;

@Component({
  selector: 'q-result-el',
  templateUrl: './result-el.component.html',
  styleUrls: ['./result-el.component.css']
})
export class ResultELComponent implements OnInit {

  constructor
    (
      protected router: Router,
      protected indParam: CoreService,
      protected service: HttpService,
      protected toastservice: ToastService,
      protected fileService: FilesManagerService,
      protected dateService: QueovalDateService,
    ) { }

  /**
   * Liste des cycles E-Learning
   */
  public listCycleEL: CycleEL[];

  public idCycleSelected: string;

  /**
   * Liste des chapitres
   */
  public listChapters: Chapter[];

  listQuestionnaire: LessonQuestionnaireModel = new LessonQuestionnaireModel();
  answerModel: AnswerModel = new AnswerModel();
  noteModel: ChartQuestionnaireModel;
  statModel: ChartQuestionnaireModel;

  lessonTitle: string;
  questionnaireName: string;
  learnerSorting: string;
  nbApprenant: number;
  elQuest: any;
  resultQuest: string;
  idLesson: string;
  modelType: string;
  modelName: string;
  idFormateur: string;
  apprenant: LearnerDetail;

  dateDebutValid: boolean;
  dateFinValid: boolean;

  /**
   * Numéro pour aller chercher la liste des apprenants
   * 0 -> les 100 premiers
   * 1 -> de 101 à 200
   * etc...
   */
  NumFetch: number;

  /**
   * Booléen pour savoir si tous les apprenants sont affichés
   */
  ShowAllLearner: boolean;

  /**
   * Booleen pour indiquer le chargement d'apprenant supplémentaires
   */
  public isLoadingMore: boolean;


  isAdminQuestionnaire: boolean;

  datePickerDebutInit: QueovalDate = new QueovalDate();
  datePickerFinInit: QueovalDate = new QueovalDate();

  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;
  @ViewChild('closeRaZBtn', { static: false }) closeRaZBtn: ElementRef;
  @ViewChild('closeRaZAllBtn', { static: false }) closeRaZAllBtn: ElementRef;
  @ViewChild('scrollToLocation') scrollToLocation: ElementRef;

  //#endregion

  //#region CYCLE DE VIE
  ngOnInit(): void {
    this.indParam.showSplash(true);
    this.isAdminQuestionnaire = this.indParam.getAutorisation('AdminQuest');

    this.noteModel = new ChartQuestionnaireModel();
    this.noteModel.chart = new Array<ChartData>();
    this.statModel = new ChartQuestionnaireModel();
    this.statModel.chart = new Array<ChartData>();
    this.idFormateur = this.indParam.AppParams.LoggedUser.Ident;

    // Initialisation des dates (récupération du mois en cours)
    this.datePickerFinInit = new QueovalDateService().Now();
    this.dateFinValid = true;
    //const dayEnd = this.datePickerFinInit.mois === '2' && this.datePickerFinInit.jour === '29' ? '28' : this.datePickerFinInit.jour;
    //this.datePickerDebutInit = new QueovalDate((Number(this.datePickerFinInit.annee) - 1).toString(), this.datePickerFinInit.mois, dayEnd);
    let dateFin = this.dateService.ToDate(this.datePickerFinInit);
    if (dateFin) {
      let dateDebut = new Date(Date.now());
      dateDebut.setMonth(dateFin.getMonth() - 1);
      this.datePickerDebutInit = this.dateService.FromDate(dateDebut);
      this.dateDebutValid = true;
    }


    this.NumFetch = 0;

    // Récupération des cycles

    this.service.getHttp<LessonQuestionnaireModel>(`${this.indParam.AppParams.UrlElearningWS}api/resultquest/LOADCYCLESEL/0`).subscribe(
      (data: LessonQuestionnaireModel) => {
        if (!data.HasError) {
          this.listCycleEL = data.CyclesEL;
        }
        this.indParam.showSplash(false);
      }, () => {
      });

  }


  //#endregion

  //#region FONCTIONS PUBLIQUES


  /**
 * Récupération des chapitres
 * @param idCycleEL ident Cycle E-Learning
 */
  getChapters(idCycleEL: string): void {
    // On vide les listes des chapitres et des leçons
    this.listChapters = new Array<Chapter>();
    this.listQuestionnaire = new LessonQuestionnaireModel();
    this.idCycleSelected = idCycleEL;
    if (!isEmptyStr(idCycleEL) && idCycleEL !== '0') {
      this.indParam.showSplash(true);
      // Récupération de la liste des chapitres du cycle
      this.service.getHttp<LessonQuestionnaireModel>(`${this.indParam.AppParams.UrlElearningWS}api/resultquest/GETLISTCHAPTERS/${idCycleEL}`).subscribe(
        (data: LessonQuestionnaireModel) => {
          this.listChapters = data.Chapters;
          this.indParam.showSplash(false);
        });
    }
  }

  /**
* Récupération des leçons avec les questionnaires
* @param idChapter ident chapitre
*/
  getLessons(idChapter: string): void {
    // On vide les listes des leçons
    this.listQuestionnaire = new LessonQuestionnaireModel();
    if (!isEmptyStr(idChapter) && idChapter !== '0') {
      this.indParam.showSplash(true);
      // Récupération de la liste des chapitres du cycle
      this.service.getHttp<LessonQuestionnaireModel>(`${this.indParam.AppParams.UrlElearningWS}api/resultquest/GETLESSONSQUEST/${idChapter}`).subscribe(
        (data: LessonQuestionnaireModel) => {
          this.listQuestionnaire.Lessons = data.Lessons;
          this.indParam.showSplash(false);
          if (!this.listQuestionnaire.Lessons || this.listQuestionnaire.Lessons.length === 0) {
            this.toastservice.showInfoToast('Pas de leçons à afficher');
          }
        });
    }
  }


  // recuperation des infos des apprenants par rapport au questionnaire selectionné
  GetLearnerResult(idLesson: string, modelType: string, modelName: string, lessonTitle: string, questionnaireName: string, numFetch: number, refresh: boolean = false): void {
    this.NumFetch = numFetch;
    if (refresh) {
      this.listQuestionnaire.LearnerList = [];
      setTimeout(() => { $('.q-imgloading').css('display', 'block'); }, 200);
    }

    if (this.NumFetch == 0) {
      this.scrollToLocation.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    // teste que les dates soient valides
    if (this.dateDebutValid && this.dateFinValid) {
      this.idLesson = idLesson;
      this.modelType = modelType;
      this.modelName = modelName;
      this.lessonTitle = lessonTitle;
      this.questionnaireName = questionnaireName;

      // $('.loader').css('display', 'block');

      if (this.NumFetch == 0) {
        setTimeout(() => { $('.q-imgloading').css('display', 'block'); }, 200);
       
      }

      this.listQuestionnaire.IdLessonSelected = idLesson;
      this.listQuestionnaire.IdCycleELSelected = this.idCycleSelected;
      this.listQuestionnaire.ModelQuestionnaire = modelType;
      this.listQuestionnaire.ModelNameQuestionnaire = modelName;
      this.listQuestionnaire.FilterDateCnxStart = this.datePickerDebutInit;
      this.listQuestionnaire.FilterDateCnxEnd = this.datePickerFinInit;
      this.listQuestionnaire.Mode = 'LEARNERRESULT';
      this.listQuestionnaire.NumFetch = numFetch;
      //  this.dialogservice.showSplash(true);


      this.service.postHttp<LessonQuestionnaireModel>(`${this.indParam.AppParams.UrlElearningWS}api/resultquest/`, this.listQuestionnaire).subscribe((data: LessonQuestionnaireModel) => {
        if (!data.HasError) {
          if ((!this.listQuestionnaire.LearnerList || this.listQuestionnaire.LearnerList.length == 0) && numFetch == 0) { 
            this.listQuestionnaire.LearnerList = data.LearnerList;
            this.nbApprenant = this.listQuestionnaire.LearnerList.length;
          }
          else {
            this.listQuestionnaire.LearnerList.push(...data.LearnerList);
            this.nbApprenant += data.LearnerList.length;
          }

          this.ShowAllLearner = data.LearnerList.length < 100;
          this.isLoadingMore = false;
        }

        if (this.NumFetch == 0) {
          setTimeout(() => { $('.q-imgloading').css('display', 'none'); }, 200);
        }
        //  this.dialogservice.showSplash(false);
        // get note question
        this.noteModel = new ChartQuestionnaireModel();
        this.noteModel.postModel.idLesson = this.listQuestionnaire.IdLessonSelected;
        this.noteModel.postModel.idStagiaire = _.map(this.listQuestionnaire.LearnerList, 'ident').join(",");
        this.noteModel.postModel.titreQuestionnaire = this.listQuestionnaire.ModelQuestionnaire;
        this.noteModel.Mode = 'GETNOTE';

        this.service.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlElearningWS}api/Chart/`, this.noteModel).subscribe((noteData: QResult<ChartQuestionnaireModel>) => {
          if (!noteData.HasError) {
            this.noteModel = noteData.Value;
          }
        });
        this.noteModel.Mode = 'GETBARQUESTION';
        this.service.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlElearningWS}api/Chart/`, this.noteModel).subscribe((questionData: QResult<ChartQuestionnaireModel>) => {
          if (!questionData.HasError) {
            this.statModel = questionData.Value;
          }
        });
      });
    }


  }

  ShowMoreLearner(): void {
    this.isLoadingMore = true;
    this.NumFetch++;
    this.GetLearnerResult(this.idLesson, this.modelType, this.modelName, this.lessonTitle, this.questionnaireName, this.NumFetch);
  }

  // redirection vers la page du questionnaire
  GoToAnswer(idLesson: string, model: string, idLearner: string, modelName: string): void {
    this.answerModel = new AnswerModel();
    //  this.answerModel.stageId = idStage;
    this.answerModel.lessonId = idLesson;
    this.answerModel.modelType = model;
    this.answerModel.learnerId = idLearner;
    this.answerModel.modeQuestionnaire = 'trainer';
    this.answerModel.modelName = modelName;
    this.answerModel.isTrainer = true;
    //  this.answerModel.formateurName = `${this.appService.Params.FirstName} ${this.appService.Params.Name}`;
  }

  // Récupération de l'état du questionnaire
  //getResult(result: string): void {
  //  this.closeBtn.nativeElement.click();
  //  this.GetLearnerResult(this.idLesson, this.modelType, this.modelName, this.lessonTitle, this.questionnaireName, this.elQuest, true);
  //  this.resultQuest = result;
  //}

  InitModalRaZ(Apprenant: LearnerDetail): void {
    this.apprenant = Apprenant;
  }

  RazInfoQuestionnaire(razAll: boolean): void {
    this.indParam.showSplash(true);
    let lessonDetail: LessonQuestionnaireModel = new LessonQuestionnaireModel();
    lessonDetail = Object.assign({}, this.listQuestionnaire);
    if (!razAll) {
      lessonDetail.LearnerList = new Array<LearnerDetail>();
      lessonDetail.LearnerList.push(this.apprenant);
    }
    lessonDetail.Mode = 'RAZQUESTLEARNER';
    this.service.postHttp<LessonQuestionnaireModel>(`${this.indParam.AppParams.UrlElearningWS}api/resultquest/`, lessonDetail).subscribe((data: LessonQuestionnaireModel) => {
      razAll ? this.closeRaZAllBtn.nativeElement.click() : this.closeRaZBtn.nativeElement.click();
      this.GetLearnerResult(this.idLesson, this.modelType, this.modelName, this.lessonTitle, this.questionnaireName, 0, true);
      this.indParam.showSplash(false);
    });
  }

  accordion(element: any, index: number): void {
    $('#btn' + index).toggleClass('accordionQuestActive');
    const panel: any = $('#panel' + index);
    if (panel.height() > 1) {
      panel.css('max-height', '0px');
    } else {
      panel.css('max-height', panel.prop('scrollHeight') + 'px');
    }
  }

  // refresh -> si la liste est déjà affichée on récupère la liste filtrée par les date choisies
  refresh(): void {
    if (this.listQuestionnaire && this.listQuestionnaire.LearnerList) {
      this.GetLearnerResult(this.idLesson, this.modelType, this.modelName, this.lessonTitle, this.questionnaireName, 0, true);
    }
    else {
      // si elle n'est pas affichée on affiche juste le loader 2s pour montrer à l'utilisateur qu'il a cliqué 
      $('.q-imgloading').css('display', 'block');
      setTimeout(() => { $('.q-imgloading').css('display', 'none'); }, 200);
    }
  }

  download(idLearner: string) {
    let model: AnswerModel = new AnswerModel();
    model = new AnswerModel();
    model.Mode = "toPdf";
    model.lessonId = this.listQuestionnaire.IdLessonSelected;
    model.modelType = this.listQuestionnaire.ModelQuestionnaire;
    model.learnerId = idLearner;
    model.modeQuestionnaire = "pdf";
    model.learnerList = this.listQuestionnaire.LearnerList.filter((learner: LearnerDetail) => { return learner.ident == idLearner });
    //  model.modeQuestionnaire = 'trainer'; 
    model.modelName = this.listQuestionnaire.ModelNameQuestionnaire;
    model.isTrainer = true;
    // model.formateurName = `${this.appService.Params.FirstName} ${this.appService.Params.Name}`;
    this.toastservice.showInfoToast('Fichier en cours de génération ...');
    this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.UrlElearningWS}api/questionnaire/`, model).subscribe((data: AnswerModel) => {
      if (!data.HasError) { }
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = 'OPENFILE';
      fileModel.FullPath = data.fileToDl;
      fileModel.Name = idLearner + '.pdf';
      this.fileService.downloadMedia(fileModel, false);
      this.indParam.showSplash(false);
    });
  }

  downloadAll() {
    let model: AnswerModel = new AnswerModel();
    model = new AnswerModel();
    model.Mode = "toPdfAll";
    model.lessonId = this.listQuestionnaire.IdLessonSelected;
    model.modelType = this.listQuestionnaire.ModelQuestionnaire;

    model.learnerList = this.listQuestionnaire.LearnerList;
    model.modeQuestionnaire = "pdf";
    model.isTrainer = true;
    //  model.modeQuestionnaire = 'trainer';
    model.modelName = this.listQuestionnaire.ModelNameQuestionnaire;
    // model.formateurName = `${this.appService.Params.FirstName} ${this.appService.Params.Name}`;
    this.toastservice.showInfoToast('Fichier en cours de génération ...');
    this.service.postHttp<AnswerModel>(`${this.indParam.AppParams.UrlElearningWS}api/questionnaire/`, model).subscribe((data: AnswerModel) => {
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = 'OPENFILE';
      fileModel.FullPath = data.fileToDl;
      fileModel.Name = this.listQuestionnaire.ModelQuestionnaire + '.zip';
      this.fileService.downloadMedia(fileModel);
      this.indParam.showSplash(false);
    });
  }

  ReturnDateLearner(date: Date): string {
    return new Date(date).toLocaleDateString(this.indParam.AppParams.culture);
  }



  //#endregion
}
